
import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import { ActivitiesSource } from "src/store/activity/types";
import { getAllCitiesByCountryAPI, getAllCountryAPI, getReleasesAPI } from "./restCallCatalogue";



export const getReleases = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getReleasesAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllCountry = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllCountryAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllCitiesByCountry = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllCitiesByCountryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));       
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
